import React from "react";

const Newspaper = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.664 3.47611L8 7.99811V14.9981L8.748 15.2651L7.621 17.5191C7.49264 17.7754 7.42088 18.0562 7.41059 18.3426C7.4003 18.629 7.45172 18.9143 7.56135 19.1791C7.67099 19.4439 7.83629 19.6821 8.04603 19.8774C8.25578 20.0727 8.50507 20.2206 8.777 20.3111L12.861 21.6721C13.3179 21.8211 13.8129 21.8018 14.2568 21.6179C14.7007 21.434 15.0643 21.0975 15.282 20.6691L16.585 18.0631L20.664 19.5201C20.8148 19.5739 20.9764 19.5907 21.1351 19.5691C21.2938 19.5475 21.4449 19.488 21.5758 19.3958C21.7068 19.3036 21.8136 19.1813 21.8875 19.0391C21.9613 18.897 21.9999 18.7393 22 18.5791V4.41711C21.9999 4.25696 21.9613 4.09919 21.8875 3.95707C21.8136 3.81494 21.7068 3.69263 21.5758 3.60041C21.4449 3.50819 21.2938 3.44876 21.1351 3.42713C20.9764 3.4055 20.8148 3.4223 20.664 3.47611ZM13.493 19.7751L9.41 18.4141L10.645 15.9431L14.687 17.3871L13.493 19.7751Z"
        fill="#3D68FF"
      />
      <path
        d="M4 15H6V8H4C2.897 8 2 8.897 2 10V13C2 14.103 2.897 15 4 15Z"
        fill="#3055D4"
      />
    </svg>
  );
};

export default Newspaper;
